export default __webpack_public_path__ + "static/media/stars.8eb64119.png";